/**
 * SocialLinks — rząd ikon serwisów społecznościowych ZARZĄDZANY Z BAZY (/admin/branding).
 *
 * Do 2026-08-31 cztery adresy (Facebook, LinkedIn, Instagram, WWW) były wpisane na sztywno
 * w `components/Sidebar.js`. Zmiana jednego linku wymagała edycji kodu, przebudowy frontu
 * i wdrożenia — a właściciel chce nimi zarządzać z panelu.
 *
 * <b>Pusta lista = ZERO ikon i zero miejsca po nich</b> (komponent zwraca null). To wprost
 * z briefu: puste miejsce po ikonach wygląda jak uszkodzony interfejs.
 *
 * `className` pozwala wołającemu podać własną klasę kontenera (Sidebar ma swoją, dopracowaną
 * pod zwijanie menu), więc komponent nie narzuca wyglądu miejscu, w którym stoi.
 */
import React from "react";
import { useBranding } from "../../context/BrandingContext";
import { socialPlatform, socialPlatformLabel } from "../../constants/socialPlatforms";
import s from "./SocialLinks.module.css";

const SocialLinks = ({ className, itemClassName, size = 16 }) => {
    const { socialLinks } = useBranding();
    const linki = Array.isArray(socialLinks) ? socialLinks : [];
    if (linki.length === 0) return null;

    return (
        <div className={className || s.row}>
            {linki.map((l) => {
                const def = socialPlatform(l.platform);
                // Nieznany kod (np. dodany na serwerze, a nie w katalogu frontu) — pomijamy zamiast
                // rysować pustą kratkę, o której nikt nie wie, co miała znaczyć.
                if (!def) return null;
                const Icon = def.Icon;
                const podpis = l.label || socialPlatformLabel(l.platform);
                return (
                    <a
                        key={l.id ?? `${l.platform}-${l.url}`}
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={itemClassName || s.item}
                        title={podpis}
                        aria-label={podpis}
                    >
                        <Icon size={size} />
                    </a>
                );
            })}
        </div>
    );
};

export default SocialLinks;
